import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React, { memo, useContext } from 'react';
import LanguageSwitcher from "../language-switcher";
import FooterContext from "./footer-context";
import { jsx as _jsx } from "react/jsx-runtime";
var FooterLanguageSwitcher = function FooterLanguageSwitcher() {
  var _useContext = useContext(FooterContext),
    pageLocales = _useContext.pageLocales,
    onLanguageSwitcherOptionClick = _useContext.onLanguageSwitcherOptionClick,
    palette = _useContext.palette;
  var switcherProps = {
    pageLocales: pageLocales,
    onLanguageSwitcherOptionClick: onLanguageSwitcherOptionClick,
    palette: palette
  };
  return /*#__PURE__*/_jsx(LanguageSwitcher, _objectSpread({}, switcherProps));
};
FooterLanguageSwitcher.displayName = 'FooterLanguageSwitcher';
export default /*#__PURE__*/memo(FooterLanguageSwitcher);